module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h1', {
    staticClass: "sigil_not_in_toc"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagevii",
      "title": "vii"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "chapter-title---IVP",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('div', [_c('div', {
    attrs: {
      "epub:type": "toc",
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/05_acknowledgments#_idTextAnchor001"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/06_ch1#_idTextAnchor015"
    }
  }, [_c('b', [_vm._v("1")]), _vm._v(" Introducing Postmodernism\t")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/07_ch2#_idTextAnchor350"
    }
  }, [_c('b', [_vm._v("2")]), _vm._v(" Criteria for Evaluating Postmodernism\t")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/08_ch3#_idTextAnchor504"
    }
  }, [_c('b', [_vm._v("3")]), _vm._v(" The Demise of Enlightenment Modernism\t")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/09_ch4#_idTextAnchor728",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4")]), _vm._v(" The Observer as Situated\t")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/10_ch5#_idTextAnchor1059",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5")]), _vm._v(" Philosophy of Language\t")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/11_ch6#_idTextAnchor1434",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6")]), _vm._v(" Truth and Social Construction\t")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/12_ch7#_idTextAnchor1597",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7")]), _vm._v(" Postmodernism and the Self\t")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/13_ch8#_idTextAnchor2009",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8")]), _vm._v(" Realism and Antirealism, Objectivity and Subjectivity\t")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/14_ch9#_idTextAnchor2454",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("9")]), _vm._v(" On Metanarratives and Oppression\t")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/15_ch10#_idTextAnchor2695",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("10")]), _vm._v(" Doubts About Metanarratives\t")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/16_ch11#_idTextAnchor2903",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("11")]), _vm._v(" Truth, Faith, and Postmodernism\t")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/17_ch12#_idTextAnchor3176",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("12")]), _vm._v(" Postmodernism and the Critique of Enlightenment Rationalism\t")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/18_ch13#_idTextAnchor3509",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("13")]), _vm._v(" The Hope of the Gospel\t")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/19_ch14#_idTextAnchor3767",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("14")]), _vm._v(" Where Do We Go from Here?\t")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/20_appendix#_idTextAnchor3794",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix: Chart on Modernism and Postmodernism")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/21_notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/22_authorindex#_idTextAnchor3800",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Author Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/23_subjectindex#_idTextAnchor3801",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Subject Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/24_scriptureindex#_idTextAnchor3803",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Scripture Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/25_praise#_idTextAnchor3804",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Praise for ")]), _c('span', {
    staticClass: "normal"
  }, [_vm._v("Understanding Postmodernism")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/26_authors#_idTextAnchor3805",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Authors")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/27_moreIVP#_idTextAnchor3806",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("More Titles from InterVarsity Press")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/28_copyright",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Copyright")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageviii",
      "title": "viii"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-917742b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/04_contents.vue
// module id = 63
// module chunks = 0